// Lettura del verbale pubblicato da parte degli associati invitati all'evento
// (titolare o dipendente con la sezione «eventi»): axios + token dell'associato.
import axios from 'axios';
import { getAuthHeader } from './otpAuthService';

export interface EventoLettura {
  _id: string;
  nome: string;
  dataEvento?: string;
  oraInizio?: string;
  oraFine?: string;
  luogo?: string;
  indirizzo?: string;
  tipologia?: { nome: string; colore?: string } | null;
}

export interface AllegatoLettura {
  _id: string;
  filename: string;
  path: string;
  mimetype?: string;
  size?: number;
}

export interface VerbaleLetturaDati {
  evento: EventoLettura;
  verbale: {
    contenuto: string;
    pubblicatoAt: string | null;
    ultimaModifica: string | null;
    allegati: AllegatoLettura[];
  };
}

const percorsoVerbale = (eventId: string) =>
  `${process.env.REACT_APP_API_BASE_URL}/associate-events/my-events/${encodeURIComponent(eventId)}/verbale`;

export const leggiVerbaleAssociato = async (eventId: string): Promise<VerbaleLetturaDati> => {
  const { data } = await axios.get(percorsoVerbale(eventId), { headers: getAuthHeader() as any });
  return data.data;
};

export const scaricaPdfVerbaleAssociato = async (eventId: string): Promise<Blob> => {
  const { data } = await axios.get(`${percorsoVerbale(eventId)}/pdf`, {
    headers: getAuthHeader() as any,
    responseType: 'blob',
  });
  return data;
};
